import { Icon } from "@iconify/react";
import Breadcrumbs from "components/Breadcrumbs";
import Link from "components/Link";
import SEO from "components/SEO";
import Text from "components/Text";
import Collapse from "components/collapse";
import SessionContext from "components/session/SessionContext";
import { pagePadding } from "data/commonClasses";
import {
  fetchParallel,
  fetchPost,
  getTranslationContent,
  isArray,
} from "functions";
import { useContext } from "react";
import { twMerge } from "tailwind-merge";
import useTranslation from "translations/hooks/useTranslation";

export default function Regulations({ categories, laws }) {
  const { t } = useTranslation();

  let {
    session: { lang },
  } = useContext(SessionContext);
  let isAr = lang == "ar";
  var breadcrumbs = [
    { text: t("home"), href: "/" },
    { text: t("lawsAndRegulations") },
  ];

  return (
    <div
      className={twMerge(
        `flex flex-col w-full min-h-screen p-0 pb-5 px-5 md:px-14`,
        pagePadding
      )}
    >
      <SEO title={t("lawsAndRegulations")} description={t("lawsDescription")} />
      <Breadcrumbs items={breadcrumbs} />
      <Text text={t("lawsAndRegulations")} sectionTitle className="mt-5" />

      <div className="flex flex-col my-5 gap-5">
        {categories &&
          isArray(categories) &&
          categories.map((category) => (
            <Collapse
              key={category?._id}
              className={"bg-lightGrey w-full"}
              lang={lang}
              title={getTranslationContent(category, "name", lang)}
            >
              <div className="h-[1px] w-full self-end bg-black" />
              <div className="bg-lightGrey mb-5">
                {category?._id &&
                  laws[category?._id] &&
                  isArray(laws?.[category?._id]) &&
                  laws[category?._id].map((law) => (
                    <Link
                      key={law._id}
                      href="/laws/article/[_id]"
                      as={`/laws/article/${law?._id}`}
                    >
                      <a href="/laws/article/[_id]">
                        <div
                          className={
                            "flex flex-row items-center mt-5 px-5 w-full"
                          }
                        >
                          <Icon
                            icon={"octicon:law-16"}
                            className={`text-black md:w-5 h-5 ${
                              isAr ? "ml-4" : "mr-4"
                            } w-1/12`}
                          />
                          <Link
                            href="/laws/article/[_id]"
                            as={`/laws/article/${law?._id}`}
                          >
                            <Text
                              className="hover:text-orange w-11/12"
                              text={getTranslationContent(law, "title", lang)}
                            />
                          </Link>
                        </div>
                      </a>
                    </Link>
                  ))}
              </div>
            </Collapse>
          ))}
      </div>
    </div>
  );
}

export async function getServerSideProps(context) {
  let { lang } = context?.query;
  let laws = {};
  let categories = [];
  let reqBody = { grouped: true, lang };
  await fetchPost({ apiName: "laws", reqBody }).then(async (res) => {
    categories = res?.response?.categories;
    let requests = [];
    isArray(categories) &&
      categories.map((category) => {
        requests.push({
          key: category._id,
          apiName: "laws",
          reqBody: {
            categoryId:
              category?._id,
            lang,
          },
        });
      });
    const data = await fetchParallel(requests);

    isArray(categories) &&
      categories.map((category) => {
        laws[category._id] = data[category._id].response;
      });
  });
  // console.log({categories,laws});

  return { props: { categories, laws } };
}
